export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11194.c938ba98.jpg";